import type { MediaSticker } from './api';

export function stickerGroupIds(sticker: MediaSticker): string[] {
  return sticker.groupIds?.length ? sticker.groupIds : [sticker.packId];
}

export function stickerBelongsToGroup(sticker: MediaSticker, groupId: string | null): boolean {
  return groupId !== null && stickerGroupIds(sticker).includes(groupId);
}

export function stickerGroupSortOrder(
  sticker: MediaSticker,
  groupId: string,
  ordinal: number,
): number {
  return (
    sticker.groupSortOrders?.[groupId] ??
    (sticker.packId === groupId ? (sticker.sortOrder ?? ordinal) : ordinal)
  );
}

export function sortStickersInGroup(
  stickers: MediaSticker[],
  groupId: string,
  allStickers = stickers,
): MediaSticker[] {
  const ordinals = new Map(allStickers.map((sticker, ordinal) => [sticker.stickerId, ordinal]));
  return stickers
    .map((sticker, ordinal) => ({ sticker, ordinal: ordinals.get(sticker.stickerId) ?? ordinal }))
    .sort(
      (a, b) =>
        stickerGroupSortOrder(a.sticker, groupId, a.ordinal) -
          stickerGroupSortOrder(b.sticker, groupId, b.ordinal) ||
        a.sticker.stickerId.localeCompare(b.sticker.stickerId),
    )
    .map(({ sticker }) => sticker);
}
